import { Json } from '../Json';
import { ApplicationEnum } from './ApplicationEnum';

export const APPLICATION_PREFIXES: Json<string, string> = {
  [ApplicationEnum.REPO_LEND]: 'RL',
  [ApplicationEnum.CLEARING_HUB]: 'CH',
  [ApplicationEnum.LIMIT_MANAGER]: 'LM',
};

export enum ClearingHubPermissions {
  CH_USER_MANAGEMENT = 'CH_USER_MANAGEMENT',
  CH_CASH_MOVEMENTS = 'CH_CASH_MOVEMENTS',
  CH_LIMIT_MANAGER = 'CH_LIMIT_MANAGER',
  CH_REPO_LEND = 'CH_REPO_LEND',
  CH_COMMISSION_STATISTIC = 'CH_COMMISSION_STATISTIC',
  CH_STP_TRADE = 'CH_STP_TRADE',
  CH_ACCOUNTS_PAGE_READ = 'CH_ACCOUNTS_PAGE_READ',
  CH_ACCOUNTS_PAGE_WRITE = 'CH_ACCOUNTS_PAGE_WRITE',
  CH_CRYPTO_CLEARING_WEB_GUI = 'CH_CRYPTO_CLEARING_WEB_GUI',
  CH_ABOS_GUI_INSTALLER = 'CH_ABOS_GUI_INSTALLER',
  CH_SNAPHSOTS = 'CH_SNAPHSOTS',
  CH_RATES_PAGE = 'CH_RATES_PAGE',
  CH_SWAP_RATE_POSTER = 'CH_SWAP_RATE_POSTER',
  CH_POSTING_METHODS = 'CH_POSTING_METHODS',
  CH_HUOBI_DEPOSIT_WITHDRAW = 'CH_HUOBI_DEPOSIT_WITHDRAW',
  CH_CRYPTO_ADDRESS_READ = 'CH_CRYPTO_ADDRESS_READ',
  CH_CRYPTO_ADDRESS_WRITE = 'CH_CRYPTO_ADDRESS_WRITE',
  CH_FIND_RECONCILIATION = 'CH_FIND_RECONCILIATION',
  CH_START_RECONCILIATION = 'CH_START_RECONCILIATION',
  CH_UPDATE_RECONCILIATION = 'CH_UPDATE_RECONCILIATION',
  CH_DOWNLOADS = 'CH_DOWNLOADS',
  CH_STATISTICS_DASHBOARD = 'CH_STATISTICS_DASHBOARD',
  CH_GOLDEN_RECORDS = 'CH_GOLDEN_RECORDS',
  CH_DIFF_TOOL = 'CH_DIFF_TOOL',
  CH_REDIS_INTERFACE = 'CH_REDIS_INTERFACE',
  CH_HAIRCUT = 'CH_HAIRCUT',
  CH_YNB_LIMIT_STREAM = 'CH_YNB_LIMIT_STREAM',
}

export enum RepoLendPermissions {
  GET_CLIENT_STATE = 'GET_CLIENT_STATE',
  ADD_ORDER = 'ADD_ORDER',
  REMOVE_ORDER = 'REMOVE_ORDER',
  CANCEL_ORDER = 'CANCEL_ORDER',
  CHANGE_CARD_QUANTITY = 'CHANGE_CARD_QUANTITY',
  CHANGE_CARD_ORDER = 'CHANGE_CARD_ORDER',
  CHANGE_CARD_CURRENCY_PAIR = 'CHANGE_CARD_CURRENCY_PAIR',
  CHANGE_CARD_TRADE_TYPE = 'CHANGE_CARD_TRADE_TYPE',
  ADD_NEW_TAB = 'ADD_NEW_TAB',
  REMOVE_TAB = 'REMOVE_TAB',
  RENAME_TAB = 'RENAME_TAB',
  MODIFY_ORDER = 'MODIFY_ORDER',
  SELECT_CLIENT = 'SELECT_CLIENT',
  GET_USERS = 'GET_USERS',
  MODIFY_ABOS_ID = 'MODIFY_ABOS_ID',
  ADMIN_CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  ADMIN_GET_USERS = 'ADMIN_GET_USERS',
  ADMIN_CREATE_USER = 'ADMIN_CREATE_USER',
  USER_CHANGE_PASSWORD = 'USER_CHANGE_PASSWORD',
  FIND_ON_BEHALF_USERS = 'FIND_ON_BEHALF_USERS',
  ADMIN_CHANGE_EMAIL = 'ADMIN_CHANGE_EMAIL',
  ADMIN_STATE = 'ADMIN_STATE',
  UPDATE_CURRENCIES = 'UPDATE_CURRENCIES',
}

export enum LimitManagerPermissions {
  BITFINEX_READ = 'BITFINEX_READ',
  BITFINEX_WRITE = 'BITFINEX_WRITE',
  BITFINEX_SWAP_READ = 'BITFINEX_SWAP_READ',
  BITFINEX_SWAP_WRITE = 'BITFINEX_SWAP_WRITE',
}

export enum AdminDashboardPermissions {
  USER_MANAGEMENT_CREATE_USER = 'USER_MANAGEMENT_CREATE_USER',
  USER_MANAGEMENT_DELETE_USER = 'USER_MANAGEMENT_DELETE_USER',
  USER_MANAGEMENT_CHANGE_USER_PASSWORD = 'USER_MANAGEMENT_CHANGE_USER_PASSWORD',
  USER_MANAGEMENT_IMPORT_USER = 'USER_MANAGEMENT_IMPORT_USER',
  USER_MANAGEMENT_UPDATE_USER_ATTRIBUTES = 'USER_MANAGEMENT_UPDATE_USER_ATTRIBUTES',
  USER_MANAGEMENT_UPDATE_USER_ROLES = 'USER_MANAGEMENT_UPDATE_USER_ROLES',
  USER_MANAGEMENT_LIST_USERS = 'USER_MANAGEMENT_LIST_USERS',
}

export enum AuthenticatorPermissions {
  FXCH_GET_PERMISSIONS = 'FXCH_GET_PERMISSIONS',
}

export enum ReleasePagePermissions {
  RP_DELETE_RELEASE = 'RP_DELETE_RELEASE',
  RP_CREATE_RELEASE = 'RP_CREATE_RELEASE',
}
// export type PERMISSION = ClearingHubPermissions;
export const PERMISSION = {
  ...ClearingHubPermissions,
  ...AuthenticatorPermissions,
  ...RepoLendPermissions,
  ...LimitManagerPermissions,
  ...AdminDashboardPermissions,
  ...ReleasePagePermissions,
};

export type PermissionType =
  | ClearingHubPermissions
  | AuthenticatorPermissions
  | RepoLendPermissions
  | LimitManagerPermissions
  | AdminDashboardPermissions
  | ReleasePagePermissions;
export const PermissionEntityType =
  ClearingHubPermissions && AuthenticatorPermissions && RepoLendPermissions;
export enum OtherPermissions {
  TEST_PERMISSION = 'TEST_PERMISSION',
}
